import cn from 'classnames';
import { forwardRef, HTMLProps } from 'react';
import { SizeType } from '../../types/props';
import s from './input.module.css';

export interface InputProps
  extends Omit<HTMLProps<HTMLInputElement>, 'size' | 'defaultValue' | 'label' | 'required'> {
  size?: SizeType;
}

export const Input = forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  const { size = 'lg', className, disabled, value, name, ...other } = props;

  const inputClassNames = cn(s.input, className, s[size], disabled && s.disabled);

  return (
    <input
      ref={ref}
      className={inputClassNames}
      disabled={disabled}
      name={name}
      value={value || ''}
      onWheel={(e) => e.currentTarget.blur()}
      {...other}
    />
  );
});
